import {BsFillXCircleFill} from 'react-icons/bs';

const Chip = ({children, cancelable, onClick}) => 
  <div className={`bf-chip ${(cancelable) ? 'cancelable' : ''}`} onClick={(onClick instanceof Function) ? onClick : null}>
    {(cancelable) ? <BsFillXCircleFill /> : null}
    {children}
  </div>

const Chips = ({children}) => <div className="bf-chips">{children}</div>
const ChipsContainer = ({children}) => <div className="bf-chips-container">{children}</div>

export { Chip, Chips, ChipsContainer }